import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../../compoment/icon/BackBtn";
import DefaultImg from './../../assets/img/selectedLanten.png'
import { useEffect, useState } from "react";
import { getTicketDetailFromStorage } from "../../utils/ticket";

const LanternSelectedScreen = () => {
    const navigate = useNavigate();
    const [wishTxt, setWishTxt] = useState<string>("");
    const [ticket, setTicket] = useState<any>(null);

    useEffect(() => {
        const storedWish = localStorage.getItem("wish");
        if (storedWish) setWishTxt(storedWish);

        const ticketDetail = getTicketDetailFromStorage();
        if (ticketDetail) {
            setTicket(ticketDetail);
        }
    }, []);
    const isLandscape = window.innerWidth > window.innerHeight;






    return (
        <>
            <section className={!isLandscape ? "colorSection portraitDevice" : "colorSection"}>
                <div className="mainContainerSection">
                    <div>
                        <button className="backBTN" onClick={() => navigate('/main')}>
                            <span className="me-2"><BackBtn /></span> Back
                        </button>
                    </div>
                    <div className="lanternContainer h-100">
                        <div className="singleLanternSelected mt-0 text-center">
                            <div className="imageContainer"><img src={DefaultImg} alt="" />
                                <div className="overlayTxt">
                                    {wishTxt}
                                    <div className="userName">{ticket?.first_name} {ticket?.last_name[0]}.</div>
                                </div>
                            </div>
                            <button className="lanternBtn" onClick={() => navigate('/today-joining')}>Submit</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default LanternSelectedScreen;
